import StoreService from '@/services/store.service'

export default {
  getListStoreByUser ({ commit }, customerId) {
    return StoreService.getStoreByUser(customerId)
      .then(store => {
        commit('SET_LIST_STORE', (store.data || []).map(s => ({ ...s, visible: true })))
      })
      .catch(error => commit('toast/NEW', { type: 'error', message: error.message }, { root: true }))
  },
  updateListStore ({ commit }, listStore) {
    commit('SET_LIST_STORE', listStore)
    return listStore
  }
}
